import { render, staticRenderFns } from "./PublishEventToWingDialog.vue?vue&type=template&id=a2bbd6fa&scoped=true"
import script from "./PublishEventToWingDialog.vue?vue&type=script&lang=js"
export * from "./PublishEventToWingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bbd6fa",
  null
  
)

export default component.exports